// components/TransitionLink.tsx
import React, { PropsWithChildren } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

type TransitionLinkProps = {
  to: string;
  className?: string;
} & PropsWithChildren<{}>;

export default function TransitionLink({ children, to, className, ...props }: TransitionLinkProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (to === location.pathname) {
      e.preventDefault();
      return;
    }

    e.preventDefault();

    navigate(to);
  };

  return (
    <Link to={to} onClick={handleClick} className={className} {...props}>
      {children}
    </Link>
  );
}
